import { ValidationUtils } from 'spanalog/lib/utils/ValidationUtils';

(function () {
  /**
   * The possible gdpr operations
   */
  const GdprOperationType = Object.freeze({
    OVERWRITE: 'GDPR_OVERWRITING',
    DELETE: 'GDPR_DELETION'
  });

  /*
   * This module produces GdprRequestData objects that maintain the state of a gdpr restore.
   */
  angular
    .module('services.gdprrequestdata', ['sbsf.constants', 'services.util'])
    .constant('GdprOperationType', GdprOperationType)
    .factory('GdprRequestDataFactory', GdprRequestDataFactory);

  GdprRequestDataFactory.$inject = ['UtilService'];

  /**
   * Generates new instance of GdprRequestData class
   * @returns {{generate: GdprRequestData}}
   * @constructor
   */
  function GdprRequestDataFactory(UtilService) {
    class GdprRequestData {
      constructor(orgInfo) {
        this.operationType = GdprOperationType.OVERWRITE;
        this.uploadFile = null;
        this.sfOrgIdValue = orgInfo.sfId;
      }

      getOperationType() {
        return this.operationType;
      }

      setOperationType(operation) {
        this.operationType = operation;
      }

      /**
       * Gets the uploaded CSV file for gdpr request.
       *
       * @returns {Object} uploadFile - the CSV file.
       */
      getUploadFile() {
        if (!this.uploadFile) {
          throw new Error('Gdpr csv file was not uploaded');
        }
        return this.uploadFile;
      }

      /**
       * Sets the selected CSV file for gdpr request.
       *
       * @param {Object} uploadFile - the CSV file.
       */
      setUploadFile(uploadFile) {
        if (UtilService.isSet(uploadFile)) {
          ValidationUtils.assertIsObject(uploadFile, 'uploadFile');
          ValidationUtils.assertIsString(uploadFile.name, 'uploadFile.name');
          this.uploadFile = uploadFile;
        } else {
          throw new Error('Gdpr operation requires uploadFile');
        }
      }

      /**
       * Returns the name of the selected CSV file for gdpr request.
       *
       * @returns {string} the name of the CSV file.
       */
      getUploadFileName() {
        return this.uploadFile && this.uploadFile.name;
      }

      get sfOrgId() {
        return this.sfOrgIdValue;
      }
    }

    return {
      // GdprRequestData is a function that produces a new object
      generate: (orgInfo) => new GdprRequestData(orgInfo)
    };
  }
})();
